import React, { useState } from 'react';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from '../../../_ui/Modal/Modal';
import Button from '../../../_ui/Button/Button';
import TextField from '@material-ui/core/TextField';
import { addEmail } from '../ReportsPageDucks';

function ReportsSettingAddEmailModal({ close, reloadPage }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const validateEmail = (value) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(value);
  };

  const handleSave = () => {
    if (!email) {
      setError(t('reportsPage_emailRequired'));
      return;
    }
    if (!validateEmail(email)) {
      setError(t('reportsPage_emailInvalid'));
      return;
    }
    setError('');
    dispatch(addEmail(email, reloadPage, close));
  };

  const handleChange = (e) => {
    setEmail(e.target.value);
    if (validateEmail(e.target.value)) {
      setError('');
    }
  };

  return (
    <Modal title={t('reportsPage_addEmailModal')} open onClose={close}>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label={t('reportsPage_emailLabel')}
          value={email}
          onChange={handleChange}
          error={!!error}
          helperText={error || ' '}
        />
      </DialogContent>
      <DialogActions>
        <Button text={t('reportsPage_cancelBtn')} onClick={close} />
        <Button text={t('reportsPage_saveBtn')} onClick={handleSave} />
      </DialogActions>
    </Modal>
  );
}

export default ReportsSettingAddEmailModal;
